<template>
  <main class="">
    <div class="card">
      <!-- ===== ЗАГОЛОВОК ===== -->
      <div class="card-header">
        <div class="icon-title">
          <!-- Иконка документа -->
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <line x1="10" y1="9" x2="8" y2="9"/>
          </svg>
          Получение файла
        </div>
      </div>

      <!-- ===== КОНТЕНТ ===== -->
      <div class="content" id="content">


        <!-- ===== СОСТОЯНИЕ: LOADING ===== -->
        <div v-if="state === 'loading'" class="state-loading" id="stateLoading">
          <div class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
          <div class="text-block">
            <h2>Загрузка файла...</h2>
            <p>Пожалуйста, подождите</p>
          </div>
          <div class="progress-bar">
            <div class="progress-fill"></div>
          </div>
        </div>

        <div v-else-if="state==='success'" class="state-success" id="stateSuccess">
          <div class="icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
</svg>
          </div>
          <div class="text-block">
            <h2>Файл успешно загружен!</h2>
            <p id="fileNameDisplay">{{ filename }}</p>
          </div>
        </div>

        <div v-else-if="state==='error'" class="state-error" id="stateError">
          <div class="icon-wrapper">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <div class="text-block">
            <h2>Ошибка загрузки</h2>
            <p id="errorMessage">Не удалось получить файл</p>
          </div>
        </div>
      </div>

    </div>
  </main>
</template>

<script>

import {ReportApi} from "@/api/report";

export default {
  name: 'ReportDownload',
  data() {
    return {
      state: "loading",
      filename: ""
    }
  },
  computed: {},
  mounted() {
    this.getReport();
  },
  methods: {
    fileResponse: function (response, name) {
      let blob = new Blob([response], {type: 'application/vnd.ms-excel'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
    },
    getReport() {
      ReportApi.protected_report_download(
          {id: this.$route.params.id, type: this.$route.params.report_type},
      ).then(response => {
        this.state = "success"
        this.filename = decodeURIComponent(response.headers.filename)
        this.fileResponse(response.data, this.filename)
      }).catch(() => this.state = "error")
    },

  }
}
</script>

<style scoped>


.card {
  margin: 0 auto;
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 36px 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08),
  0 4px 16px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.3s ease;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card:hover {
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.12),
  0 4px 16px rgba(0, 0, 0, 0.04);
}

.card-header {
  text-align: center;
  margin-bottom: 32px;
}

.card-header .icon-title {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}

.card-header .icon-title svg {
  width: 28px;
  height: 28px;
  color: #2563eb;
  flex-shrink: 0;
}

.card-header .subtitle {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
}

.content {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.state-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.spinner-wrapper {
  position: relative;
  padding: 16px;
  background: #eff6ff;
  border-radius: 9999px;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #bfdbfe;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.state-loading .text-block {
  text-align: center;
}

.state-loading .text-block h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.state-loading .text-block p {
  font-size: 14px;
  color: #6b7280;
}

.progress-bar {
  width: 100%;
  max-width: 200px;
  height: 6px;
  background: #e5e7eb;
  border-radius: 999px;
  overflow: hidden;
}

.progress-bar .progress-fill {
  height: 100%;
  width: 60%;
  background: #2563eb;
  border-radius: 999px;
  animation: pulse-progress 1.2s ease-in-out infinite;
}

@keyframes pulse-progress {
  0% {
    opacity: 0.6;
    width: 30%;
  }
  50% {
    opacity: 1;
    width: 70%;
  }
  100% {
    opacity: 0.6;
    width: 30%;
  }
}

.state-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  animation: fadeUp 0.4s ease;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.state-success .icon-wrapper {
  padding: 16px;
  background: #ecfdf5;
  border-radius: 9999px;
}

.state-success .icon-wrapper svg {
  width: 48px;
  height: 48px;
  color: #22c55e;
  display: block;
}

.state-success .text-block {
  text-align: center;
}

.state-success .text-block h2 {
  font-size: 20px;
  font-weight: 600;
  color: #16a34a;
  margin-bottom: 4px;
}

.state-success .text-block p {
  font-size: 14px;
  color: #4b5563;
  word-break: break-all;
}

.state-success .badge {
  display: inline-block;
  font-size: 13px;
  color: #6b7280;
  padding: 4px 14px;
  background: #f3f4f6;
  border-radius: 999px;
}

.state-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  animation: shake 0.5s ease;
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-12px);
  }
  40% {
    transform: translateX(12px);
  }
  60% {
    transform: translateX(-8px);
  }
  80% {
    transform: translateX(8px);
  }
}

.state-error .icon-wrapper {
  padding: 16px;
  background: #fef2f2;
  border-radius: 9999px;
}

.state-error .icon-wrapper svg {
  width: 48px;
  height: 48px;
  color: #ef4444;
  display: block;
}

.state-error .text-block {
  text-align: center;
}

.state-error .text-block h2 {
  font-size: 20px;
  font-weight: 600;
  color: #dc2626;
  margin-bottom: 4px;
}

.state-error .text-block p {
  font-size: 14px;
  color: #ef4444;
}

@media (max-width: 480px) {
  .card {
    padding: 28px 20px 24px;
  }

  .card-header .icon-title {
    font-size: 20px;
  }

  .state-loading .text-block h2,
  .state-success .text-block h2,
  .state-error .text-block h2 {
    font-size: 18px;
  }
  .content {
    min-height: 240px;
    gap: 16px;
  }
}
</style>